import { Link, useLocation } from "react-router-dom";
import { Beaker, Menu, X, Calculator, Home, Package } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import logo from "../../assets/axeon-chemical.svg";

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { path: "/", label: "Home", icon: Home },
    { path: "/products", label: "All Products", icon: Package },
    { path: "/calculator", label: "Calculator", icon: Calculator },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="industrial-header sticky top-0 z-50" data-testid="main-header">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
            <Link 
              to="/" 
              className="flex items-center gap-3 text-white"
              data-testid="header-logo"
            >
            {/* <div className="w-10 h-10 rounded-lg bg-[#00BCD4] flex items-center justify-center">
              <Beaker className="w-6 h-6 text-white" />
            </div>
            <div className="hidden sm:block">
              <span className="font-bold text-xl tracking-tight">AXEON</span>
              <span className="text-[#00BCD4] text-sm block -mt-1">Chemical Selection</span>
            </div> */}

            <div>
      <img src={logo} alt="Logo" width="300" />
    </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg transition-all duration-200 ${
                  isActive(item.path)
                    ? "bg-sky-500/100 text-white"
                    : "text-black-300 hover:text-white hover:bg-sky-500/50"
                }`}
                data-testid={`nav-${item.label.toLowerCase().replace(' ', '-')}`}
              >
                <item.icon className="w-4 h-4" />
                <span className="font-medium">{item.label}</span>
              </Link>
            ))}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden items-center gap-3">
            <Link to="/admin">
              <Button 
                variant="ghost" 
                className="text-black-300 hover:text-white hover:bg-sky-500/50"
                data-testid="admin-link"
              >
                Admin
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 text-slate-800"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-toggle"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-white/10">
            <nav className="flex flex-col gap-2">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setMobileMenuOpen(false)}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-all ${
                    isActive(item.path)
                      ? "bg-white/15 text-slate-600"
                      : "text-slate-300 hover:text-white hover:bg-white/10"
                  }`}
                >
                  <item.icon className="w-5 h-5" />
                  <span className="font-medium">{item.label}</span>
                </Link>
              ))}
              <Link
                to="/admin"
                onClick={() => setMobileMenuOpen(false)}
                className="hidden items-center gap-3 px-4 py-3 rounded-lg text-slate-300 hover:text-white hover:bg-white/10"
              >
                <span className="font-medium">Admin Panel</span>
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
